<template>
    <ResultsTypePickerContainer>
        <div slot-scope="{ items, selectedItem }">
            <div
                v-if="isLeftSidebarOpen || isRightSidebarOpen"
                class="modal__overlay"
                @click="closeAllMenus"
            >
            </div>
            <PrimaryNavItem
                v-if="getSelectedSubItem(selectedItem)"
                @click="onLeftItemClick"
                :selectedItem="getSelectedSubItem(selectedItem)"
                :isSidebarExpanded="isLeftSidebarOpen"
            />
            <div
                v-else
                @click="onRightItemClick"
                class="mobile-subnav__item"
            />
            <button
                class="mobile-subnav__item mobile-subnav__item--secondary"
                @click="onRightItemClick"
            >
                <div class="mobile-subnav__item-text">
                    {{ selectedItem.label | upperCase }}
                </div>
            </button>
        </div>
    </ResultsTypePickerContainer>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ResultsTypePickerContainer from '@src/app/shared/components/Results/ResultsTypePickerContainer.vue';
    import { getSportNavItem, getLottoNavItem } from '@app/mobile/helpers/navigation';
    import PrimaryNavItem from '@app/mobile/components/PrimaryNavItem';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        computed: {
            ...mapGetters('ui/results/sport', [
                'tree',
                'breadcrumbIds',
                'selectedTreeItem',
                'breadcrumbIds',
            ]),
            ...mapGetters('ui/results/lotto', {
                lottoSelectedTreeItems: 'selectedTreeItems',
                isSystemFilter: 'isSystemFilter',
            }),
            ...mapGetters('data/sportOffer', [
                'tournaments',
                'categories',
                'sports',
            ]),
            ...mapGetters('data/games', [
                'virtualGames',
            ]),
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isLeftSidebarOpen() {
                return this.isSidebarOpen(SidebarId.resultsSecondaryNav);
            },
            isRightSidebarOpen() {
                return this.isSidebarOpen(SidebarId.resultsPrimaryNav);
            }
        },
        methods: {
            ...mapActions('ui/results/sport', [
                'selectTreeItem',
            ]),
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar',
            ]),
            onLeftItemClick() {
                this.toggleSidebar(SidebarId.resultsSecondaryNav);
            },
            onRightItemClick() {
                this.toggleSidebar(SidebarId.resultsPrimaryNav);
            },
            closeAllMenus() {
                this.closeSidebar();
            },
            getSelectedSubItem(selectedResultType) {
                if (selectedResultType.label === 'sport' || selectedResultType.label === 'live') {
                    let item = {
                        name: this.$t('all'),
                        icon: ['icon--md', 'icon-sport--1000'],
                    };
                    item = getSportNavItem(this.selectedTreeItem, item, {
                        selectedTreeItems: this.breadcrumbIds.map((id) => ({ id })),
                        sports: this.sports,
                        tournaments: this.tournaments,
                        categories: this.categories,
                    });
                    return item;
                }
                if (selectedResultType.label === 'lotto') {
                    return getLottoNavItem({
                        featuredLottoGame: [],
                        selectedFeaturedItem: null,
                        selectedTreeItems: this.lottoSelectedTreeItems,
                        isSystemFilter: this.isSystemFilter,
                    });
                }
                if (selectedResultType.label === 'shops') {
                    const selectedItem = this.$route.params.gameType || this.virtualGames[0].name;
                    return {
                        name: selectedItem,
                    };
                }
                if (selectedResultType.label === 'virtual') {
                    const selectedItem = this.$route.params.gameType;
                    return {
                        name: selectedItem,
                    };
                }

                return null;
            }
        },
        components: {
            ResultsTypePickerContainer,
            PrimaryNavItem,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/results/ResultsSubNav.vue